import { useRouteError } from 'react-router-dom';
import { Link } from 'react-router-dom';

export default function ErrorBoundary() {
  const error = useRouteError();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full px-6 py-8 bg-white rounded-lg shadow-md">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-red-600 mb-4">
            {error.status === 404 ? '404 - Page Not Found' : 'Oops! Something went wrong'}
          </h1>
          <div className="text-gray-600 mb-6">
            {error.status === 404 
              ? "We couldn't find the page you're looking for."
              : "We encountered an unexpected error. Our team has been notified."}
          </div>
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-block px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Return Home
            </Link>
            {error.status !== 404 && (
              <p className="text-sm text-gray-500 mt-4">
                Error details: {error.message || 'Unknown error'}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
